import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BrowserRouter } from 'react-router-dom';
import { Route, Routes } from 'react-router';
import Welcome from './Welcome';
import Login from './Login';
import Home from './Home';
import Contactus from './Contactus';
import Gallery from './Gallery';
import Notifications from './Notifications';
import ImageUploader from './Component/ImageUploade';
import GalleryImageUploader from './Component/GalleryImageUploader';
import Admin from './Admin';
import MyCarousel from './Component/Comp';



function App() {

  return (

    <BrowserRouter>
      <Routes>
        <Route path='/' element={<Welcome />} />
        <Route path='/Login' element={<Login />} />
        <Route path='/Home' element={<Home />} />
        <Route path='/Contactus' element={<Contactus />} />
        <Route path='/Gallery' element={<Gallery />} />
        <Route path='/Notifications' element={<Notifications />} />
       <Route path='/Imagetest' element={<ImageUploader />} /> 
       <Route path='/GImage' element={<GalleryImageUploader />}/>
       <Route path='/Admin' element={<Admin />} />
       <Route path='/comp' element={<MyCarousel />}/>
    
      </Routes>
    </BrowserRouter>
  )
}

export default App
